import React, { useState, useEffect } from 'react';
import { Col, Modal, Row, Image } from 'react-bootstrap';
import ENGModalBody from '../../../components/modal/ENGModalBody';
import ENGModalHeader from '../../../components/modal/ENGModalHeader';
import 'bootstrap/dist/css/bootstrap.min.css';
import VideoIcon from '../../../assets/images/video-line.svg';
import Add from '../../../assets/images/ic-add.svg';
import Back from '../../../assets/images/ic-arrow-back.svg';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { isPermited } from '../../../features/localStorage';
import {
  GetAwarenessModule,
  selectAwarenessModule
} from '../../../features/learning/AwarenessSlice';
import EmptyRow from '../../../components/emptyRow/EmptyRow';
import VideoItem from '../../../components/card/VideoItemAdmin';
import {
  GetInsertMaterial,
  selectInsertMaterial
} from '../../../features/learning/insertMaterialSlice';
import { Form, InputGroup } from 'react-bootstrap';
import Search from '../../../assets/images/search-line.svg';
import FileUploadImage from '../../../components/textField/FileUploadImages';
import FileUpload from '../../../components/textField/FileUpload';
import Feedback from '../../../components/feedbackNote/Feedback';
import Dropdown from '../../../components/dropdown/Dropdown';

import { useForm } from 'react-hook-form';
import MultiSelectCompany from '../../../components/textField/MultiSelectCompany';
import {
  GetAllCompany,
  selectAllCompany
} from '../../../features/company/companyListSlice';
import {
  GetCategoryList,
  GetCategoryListAsync
} from '../../../features/learning/CategorySlice';
import { useParams } from 'react-router-dom';
// Messages
const required = 'This field is required';
const pattern = 'Please insert valid input';
// Error Component
const errorMessage = (error: any) => {
  return <div className='invalid-feedback'>{error}</div>;
};
const VideoModulesDetails = () => {
  const params = useParams();
  const dispatch = useAppDispatch();

  const { categoryId }: any = params || '';

  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);
  const AwarenessModule = useAppSelector(selectAwarenessModule);
  const allCompany = useAppSelector(selectAllCompany);
  const [comapnyList, setCompanyList] = useState<any>();
  const [ofset, setOfset] = useState(0);
  const [companyId, setCompanyId] = useState([]);
  const [buId, setBuId] = useState(1);
  const [sectorId, setSectorId] = useState(1);
  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const isAdmin = localStorage.getItem('isAdmin');
  const isAdminList: any = isAdmin;
  const isAdminJson = JSON.parse(isAdminList);

  useEffect(() => {
    var data = {
      keyword: '',
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId
    };
    async function fetchAwarenessModuleData() {
      let sample = await dispatch(GetAwarenessModule(data));
    }
    fetchAwarenessModuleData();
  }, [companyId]);

  useEffect(() => {
    if (categoryId) {
      setCategory(categoryId);
    }
  }, [categoryId]);

  var searchParams: any;
  const handleShow = () => {
    setModalShow(true);
    if (isAdminJson === false) {
      // call non sso comapny with id
      const fetchCompany = async () => {
        await dispatch(
          GetAllCompany(
            (searchParams = { type: 2, id: userDetailsJson.companyId })
          )
        );
      };
      fetchCompany();
    } else {
      // call sso +non sso company
      const fetchAllComany = async () => {
        await dispatch(GetAllCompany((searchParams = { type: '', id: 0 })));
      };
      fetchAllComany();
    }
  };
  // useEffect(()=>{
  //   setCompanyList(allCompany)
  // },[comapnyList])
  // Modal Code end
  const [titleFeild, setTitle] = useState('');
  const [file, setFile] = useState('');
  const [thumbnail, setthumbnail] = useState('');
  const [description, setDescription] = useState('');
  const [paste, setPaste] = useState('');
  const [category, setCategory] = useState('');
  const InsertMaterial = useAppSelector(selectInsertMaterial);
  const [pasteLink, setPasteLink] = useState(true);
  // Modal Code end
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = async (event: any) => {
    // event.preventDefault();
    var setBuid = buId.toString();
    var setSectorId = sectorId.toString();
    var setCompnayId = companyId.toString();
    var data = {
      title: titleFeild,
      moduleId: 3,
      mediaType: 'Documents',
      thumbnail: thumbnail,
      materialPath: file,
      externalUrl: paste,
      moduleType: 'Learning Modules',
      companyId: setCompnayId,
      status: 0,
      buid: setBuid,
      sectorId: setSectorId,
      materialCategory: category
    };
    // console.log(data, "videoData");
    await dispatch(GetInsertMaterial(data));
    var getdata = {
      keyword: '',
      offset: 0,
      companyId: userDetailsJson.companyId
    };
    dispatch(GetAwarenessModule(getdata));
    handleClose();
  };

  const [searchData, setsearchData] = useState('');

  const searchItems = async (searchValue: any) => {
    await setsearchData(searchValue);
    var data = {
      keyword: searchData,
      offset: 0,
      companyId: userDetailsJson.companyId
    };

    await dispatch(GetAwarenessModule(data));
  };

  const handleChangeCheckbox1 = (e: any) => {
    setPasteLink(true);
  };
  const handleChangeCheckbox2 = (e: any) => {
    setPasteLink(false);
  };

  const categoryList = useAppSelector(GetCategoryList);
  const [dataList, setDataList] = useState<any>([]);

  useEffect(() => {
    dispatch(GetCategoryListAsync());
  }, []);

  useEffect(() => {
    if (categoryList?.length > 0) {
      let list: any = [];
      // let categoryDropdown: any = [];
      categoryList?.map((val: any) => {
        let obj = {
          id: val?.id,
          name: val?.categoryName,
          title: val?.categoryName,
          description: val?.categoryDescription,
          externalUrl: `/learning/${val?.id}`
        };
        list = [...list, obj];
      });
      setDataList([...list]);
    }
  }, [categoryList]);

  return (
    <>
      <Feedback pageName='Learning And Awarness' />
      <Row>
        <Col sm={12}>
          <a href='/learning'>
            <span style={styles.backstyle}>
              <Image src={Back} />
              Back{' '}
            </span>
          </a>
        </Col>
      </Row>
      <EmptyRow />
      <Row>
        <Col sm={7}>
          <h4>Videos</h4>
        </Col>
        <Col sm={1}>
          {isPermited(3, 2) && (
            <a onClick={handleShow}>
              {' '}
              <span style={styles.editstyle}>
                <Image src={Add} /> ADD
              </span>
            </a>
          )}

          <Modal
            show={modalShow}
            onHide={handleClose}
            backdrop='static'
            size='lg'
            keyboard={false}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <ENGModalHeader icon={VideoIcon} title=' Add New Video ' />
              <ENGModalBody
                contents={
                  <>
                    <Row style={styles.divWhite}>
                      <Col lg={12}>
                        <input
                          type='radio'
                          name='videobutton'
                          onClick={handleChangeCheckbox1}
                          id='name'
                          defaultChecked={true}
                        />
                        Paste URL &nbsp;&nbsp;
                        <input
                          type='radio'
                          onClick={handleChangeCheckbox2}
                          name='videobutton'
                          id='rollno'
                        />
                        Upload Video
                      </Col>
                    </Row>

                    <form>
                      <Row style={styles.divWhite}>
                        <Row>
                          <Col sm={12} className='desk'>
                            <label htmlFor='Unit'>
                              Category <span style={styles.star}> * </span>
                            </label>
                            <Dropdown
                              id='Category'
                              data={dataList}
                              value={category}
                              onchange={setCategory}
                              isRequired
                            />
                          </Col>
                          <EmptyRow />
                          <Col sm={12}>
                            <div className='floating-label-group'>
                              <input
                                type='text'
                                name='title'
                                ref={register({
                                  required: true,
                                  pattern: /^[a-zA-Z0-9\s]*$/g
                                })}
                                className='textstyle'
                                onChange={(
                                  ev: React.ChangeEvent<HTMLInputElement>
                                ): void => setTitle(ev.target.value)}
                              />
                              <label className='floating-label'>
                                Title <span style={styles.star}> * </span>
                              </label>
                            </div>
                            {errors.title &&
                              errors.title.type === 'required' &&
                              errorMessage(required)}
                            {errors.title &&
                              errors.title.type === 'pattern' &&
                              errorMessage(pattern)}
                          </Col>
                          <EmptyRow />
                        </Row>
                        <EmptyRow />
                        <Row>
                          {pasteLink === true ? (
                            <Col sm={6}>
                              <div className='floating-label-group'>
                                <input
                                  type='text'
                                  name='paste'
                                  ref={register({ required: true })}
                                  className='textstyle'
                                  onChange={(
                                    ev: React.ChangeEvent<HTMLInputElement>
                                  ): void => setPaste(ev.target.value)}
                                />
                                <label className='floating-label'>
                                  Paste URL <span style={styles.star}> * </span>
                                </label>
                              </div>
                              {errors.paste &&
                                errors.paste.type === 'required' &&
                                errorMessage(required)}
                            </Col>
                          ) : (
                            <Col sm={6}>
                              <FileUpload
                                setFile={setPaste}
                                title='Upload Video'
                                fileValue=''
                                fileType='MP4'
                              />
                            </Col>
                          )}
                          <Col sm={6}>
                            <FileUploadImage
                              setFile={setthumbnail}
                              title='Thumbnail'
                              fileValue=''
                              fileType='JPG/JPEG/PNG'
                            />
                          </Col>
                          <Col lg={6} className='mt-0'>
                            <label htmlFor='Unit'>Accessible To</label>
                            {/* <MultiSelectCompany SectorList={allCompany} setCompanyId={setCompanyId} /> */}
                            <MultiSelectCompany
                              optionList={allCompany}
                              setId={setCompanyId}
                              selectedValue={''}
                              valueKey='id'
                              labelKey='company'
                              isAdd={true}
                            />
                          </Col>
                        </Row>
                      </Row>
                    </form>
                  </>
                }
              />
              <EmptyRow />
              <EmptyRow />
              <Row style={styles.divGrey}>
                <Col sm={9}></Col>
                <Col sm={3}>
                  <button
                    type='button'
                    onClick={handleClose}
                    style={styles.button1}
                  >
                    {' '}
                    CANCEL{' '}
                  </button>
                  <button type='submit' style={styles.button}>
                    {' '}
                    SAVE{' '}
                  </button>
                </Col>
              </Row>
            </form>
          </Modal>
        </Col>
        {/* <Col sm={1}>
                {isPermited(3,3) &&
                <a href="/videomodulesEditDetails"><span style={styles.editstyle}><Image src={Edit} /> EDIT</span></a>
                }
                </Col> */}
        <Col sm={4}>
          <InputGroup
            className='border bg-white'
            style={{ border: 'solid 1px #e4e4e4' }}
          >
            <Image
              style={styles.image1}
              className='d-inline border-0 my-auto mx-2'
              src={Search}
              fluid
            />
            <Form.Control
              onChange={(e) => searchItems(e.target.value)}
              name={searchData}
              className='border-0 shadow-none ps-0'
              style={styles.text1}
              type='text'
              placeholder='Search'
            />
          </InputGroup>
        </Col>
      </Row>
      <EmptyRow />

      <div style={{ marginBottom: '20px' }}>
        <Row>
          {AwarenessModule.map((item: any) => (
            <VideoItem item={item} columns={3} />
          ))}
        </Row>
      </div>
    </>
  );
};

const styles: any = {
  selectpoperty: {
    backgroundColor: 'white',
    paddingBottom: '0px',
    border: 'solid 1px #e4e4e4',
    width: '100%',
    fontFamily: 'Saira',
    fontSize: '16px',
    color: '#6d6e71',
    borderRadius: '0px'
  },
  star: { color: '#e31837' },
  backstyle: {
    color: '#e31837',
    fontFamily: 'Georama-Regular',
    fontWeight: 600,
    fontSize: '12px',
    marginTop: '10px'
  },
  editstyle: {
    color: '#e31837',
    fontFamily: 'Georama-Regular',
    fontWeight: 600,
    fontSize: '12px',
    float: 'right',
    marginTop: '10px'
  },
  divWhite: {
    backgroundColor: '#fffff',
    paddingTop: '20px',
    paddingLeft: '20px',
    paddingRight: '20px'
  },

  button: {
    padding: '13px 20px',
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px',
    color: '#fff',
    float: 'right'
  },
  button1: {
    padding: '13px 20px',
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#ffffff',
    border: '1px solid #e31837',
    letterSpacing: 'normal',
    color: '#e31837'
  },
  divGrey: {
    backgroundColor: 'rgb(250, 249, 249)',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '20px',
    borderTop: '1px solid #eee;'
  },

  checkb: {
    boxSizing: 'border-box',
    width: '15px',
    height: '15px'
  },

  add: {
    padding: '0px',
    fontWeight: '600',
    fontSize: '12px',
    color: '#e31837',
    fontFamily: 'Georama-Regular',
    float: 'right'
  },

  del: {
    padding: '0px',
    fontWeight: '600',
    fontSize: '12px',
    color: '#e31837',
    fontFamily: 'Georama-Regular'
  },

  tabHeading: {
    fontFamily: 'Georama-Regular',
    fontSize: '14px',
    fontWeight: '500',
    color: '#6d6e71'
  },
  line: {
    height: '1px',
    margin: '0px',
    backgroundColor: '#f4f4f4'
  },
  colBorder: {
    border: 'solid 1px #e4e4e4'
  },
  colBorder1: {
    border: 'solid 1px #e4e4e4',
    height: '100%'
  },
  text1: {
    fontFamily: 'Georama-Regular',
    fontSize: '16px',
    fontWeight: 'normal',
    border: 'solid 1px #e4e4e4',
    borderTop: '0px',
    borderLeft: '0px',
    borderRight: '0px',
    color: '#6d6e71',
    textAlign: 'left'
  },
  heading: {
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: '500',
    color: '#6d6e71'
  },
  data: {
    fontFamily: 'Georama-Regular',
    fontSize: '16px',
    fontWeight: '500',
    color: 'black'
  },
  link: {
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: '600',
    color: '#e31837',
    lineHeight: '2',
    textTransform: 'uppercase',
    textDecoration: 'none'
  }
};

export default VideoModulesDetails;
